import { parsePhoneNumber } from 'awesome-phonenumber';
import { TFunction } from 'i18next';

export const getInternationalPhone = (phone?: string | null | undefined) => {
  if (!phone) return '';
  let pn = parsePhoneNumber(phone);
  if (pn.valid) return phone;

  pn = parsePhoneNumber(phone, { regionCode: 'US' });
  return pn.number?.international ?? phone;
};

export const formatAddressShort = ({
  addressLine1,
  city,
  stateProvinceRegionCode,
  zipPostalCode,
}) => `${addressLine1}, ${city} ${stateProvinceRegionCode} ${zipPostalCode}`;

export const getBusinessTypes = (t: TFunction, showCentralStation = false) => {
  const types: [string, string][] = [
    ['ELECTRICAL', t('common.proCategories.ELECTRICIAN')],
    ['HVAC', t('common.proCategories.HVAC')],
    ['PLUMBING', t('common.proCategories.PLUMBER')],
    ['SECURITY', t('common.proCategories.SECURITY')],
    ['UTILITY_AGGREGATOR', t('common.proCategories.UTILITY')],
  ];

  if (showCentralStation) {
    types.unshift([
      'CENTRAL_STATION',
      t('common.proCategories.CENTRAL_STATION'),
    ]);
  }

  return new Map(types);
};

export function notEmpty<T>(data: T | null | undefined): data is T {
  return data !== null && data !== undefined;
}

export const formatFileSize = (bytes?: number | null): string => {
  if (typeof bytes !== 'number' || bytes === null) return '';

  const units = ['B', 'KB', 'MB', 'GB'];

  let size = bytes;
  let unit = 0;
  while (size >= 1024 && unit < units.length - 1) {
    size /= 1024;
    unit++;
  }

  return (unit === 0 ? size : size.toFixed(2)) + ' ' + units[unit];
};

export const formatDate = (timestamp: number): string => {
  const date = new Date(timestamp);

  const month = date.toLocaleDateString('default', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
};
